exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".picker-overlay{display:block;width:100vw;height:100vh;position:fixed;top:0;left:0;background:rgba(0,0,0,.7);z-index:9999999999;text-align:center}.colour-container{display:block;width:50px;height:80px}.colour-container .colour-block{display:block;width:50px;height:50px;background-color:#fff;overflow:hidden;position:relative}.colour-container .colour-block .colour-block-bg,.colour-container .colour-block .colour-block-fg{display:block;transform:rotate(45deg);transform-origin:100% 0;width:50px;height:100px;position:absolute;top:0;left:0;cursor:pointer}.colour-container .colour-block .colour-block-bg:hover,.colour-container .colour-block .colour-block-fg:hover{opacity:.5}.colour-container .colour-block .colour-block-fg{transform:rotate(45deg);transform-origin:100% 0;top:20px;left:50px}.colour-container .colour-label{display:block;width:50px;height:15px;line-height:15px;text-transform:uppercase;text-align:center;font-size:.7em;color:#999;font-family:Andale Mono,monospace}.photoshop-picker{margin:35vh auto!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/stylus-loader!./ui/color/styles.styl
// module id = 944
// module chunks = 0